module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/SV8GO3/tc-custom/9781439666197.jpg?1697744543367",
      "alt": "This image is the cover for the book Bay Area Coffee"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Bay Area Coffee\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("Discover the rich history of San Francisco’s coffee culture from its roots in the nineteenth century to today’s celebrated artisanal roasters.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" San Francisco was booming in the mid-nineteenth century, and along with adventurers seeking their fortunes came sacks of green coffee beans. The old Yerba Buena Cove swiftly filled with ships, and the city emerged as the third-largest coffee port in the United States."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" What followed was the rise—and local demise—of the “big three” coffee roasters: Folger’s, Hills Brothers and MJB. Specialized Bay Area roasters like Peerless, Peet’s and Blue Bottle sprang up in their wake, while places such as Tosca’s, Caffé Trieste and the Blue Unicorn blazed the way for modern coffeehouses. In "), _c('i', [_vm._v("Bay Area Coffee")]), _vm._v(", Monika Trobits explores how the humble coffee bean became an ever-evolving stable of San Francisco Bay.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Monika Trobits, George Vukasin\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Monika Trobits has lived in San Francisco for more than thirty-five years. She is a New Yorker by birth and a San Franciscan by choice. Monika earned a BA in political science/history from San Francisco State University. In addition to her work in the corporate world, she was a docent for historically based organizations and local tour operators for more than twenty-five years. In 2011, Monika established her own tour company, San Francisco Journeys ,and is the author of Antebellum and Civil War San Francisco.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    The History Press\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0